import { AbstractScatterVisualization } from './../visualization.abstract.scatter.component';
export class LinearDiscriminantAnalysisGraph extends AbstractScatterVisualization {
}
